// Core
import React from 'react';
import { Transition } from 'react-transition-group';

import {
  BrowserRouter as Router,
  Route,
  Link
} from 'react-router-dom'


import Header from './js/components/Header'
import Home from './js/components/Home'
import Work from './js/components/Work'
import Skills from './js/components/Skills'
import Labs  from './js/components/Labs'
import Footer  from './js/components/Footer'

import './scss/main.scss';
import css from './scss/App.scss';


const duration = 300;
const defaultStyle = {
  transition: `opacity ${duration}ms ease-in-out`,
  opacity: 0
}

const transitionStyles = {
  entering: { opacity: 0 },
  entered: { opacity: 0.7 },
};

class App extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showVideo: true
    }
  }
  setParentState = (state) => {
    this.setState(state)
  }
  render() {
    const standardProps = {
      setParentState: this.setParentState
    }
    console.log('re rendering', this.state.showVideo)
    return (
      <Router>
        <div>
          <Header/>
          {/*
          <Transition in={ this.state.showVideo } timeout={ duration }>
            {(state) => (
              <video className={ css.bulb } preload="auto" autoPlay="true" loop="loop" muted="muted" style={{
                ...defaultStyle,
                ...transitionStyles[state]
              }}>
                <source src="video/bulb.mp4" type="video/mp4" />
                <source src="video/bulb.ogv" type="video/webm" />
                <source src="video/bulb.ogv" type="video/ogg" />
              </video>
            )}
          </Transition>
          */}
          <Route exact path="/" render={ () => <Home { ...standardProps } /> } />
          <Route path="/work" render={ () => <Work { ...standardProps } /> } />
          <Route path="/skills" render={ () => <Skills { ...standardProps } /> } />
          {/* <Route path="/labs" render={ () => <Labs { ...standardProps } /> } /> */}
          <Footer />
        </div>
      </Router>
    )
  }
}

export default App;

/*
import React from 'react'
import { withRouter, Switch, Route } from 'react-router-dom'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import Layout from './Layout'
import HomePage from './HomePage'
import ArticlesPage from './ArticlesPage'
import NotFoundPage from './NotFoundPage'

const App = ({ location }) => {
  const currentKey = location.pathname.split('/')[1] || '/'
  const timeout = { enter: 300, exit: 200 }
  
  return (
    <Layout>
      <TransitionGroup component="main" className="page-main">
        <CSSTransition key={currentKey} timeout={timeout} classNames="fade" appear>
          <section className="page-main-inner">
            <Switch location={location}>
              <Route path="/" exact component={HomePage} />
              <Route path="/articles" component={ArticlesPage} />
              <Route component={NotFoundPage} />
            </Switch>
          </section>
        </CSSTransition>
      </TransitionGroup>
    </Layout>
  )
}

export default withRouter(App)
*/


// WEBPACK FOOTER //
// ./app/App.js